export const RESET_CARDS_ACTION = 'reset-homepage-cards';
export const SET_LOGIN_ACTION = 'set-as-login';
export const ADD_CUSTOM_NAV_LINK = 'add-custom-nav-link';
